module.exports = __webpack_public_path__ + "img/info_dark.f6fc0af5.svg";